<template>
    <div class="inventory">
      <IndexPage ></IndexPage>
      <el-row class="tac">
        <el-col :span="4">
          <el-menu default-active="1"  class="el-menu-vertical-demo" @select="beforeFindItem">
            <template >
                <el-menu-item v-for="inventory in inventoryTime" :key="inventory.id" :index="inventory.id + ''">
                        <i class="el-icon-menu"></i>
                        <span>{{inventory.time}}</span>
                </el-menu-item>
            </template>
          </el-menu>
        </el-col>
        <el-col :span="18" >
          <div style="margin-top:3%;margin-left:10%" >
            <el-card shadow="always" v-if="selectInventoryId!=''">
              <el-radio-group v-model="tableState" @input="findItem">
                <el-radio label="Stocked">已盘货</el-radio>
                <el-radio label="UnStocked">未盘货</el-radio>
                <el-button type="primary" size="mini"  @click="downExcle">导出</el-button>
              </el-radio-group>
                <el-table
                  :data="items.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) ||data.brand.toLowerCase().includes(tableSearch.toLowerCase())||data.properties.toLowerCase().includes(tableSearch.toLowerCase()) )"
                  :max-height="tableHight"
                  style="width: 100%;margin-top:1.5%"
                  :empty-text="loadInfo"
                  v-if="tableState!=''">
                  <el-table-column
                    label="序号"
                    type="index"
                    width=80px>
                  </el-table-column>

                  <!-- <el-table-column
                    label="商品 ID"
                    prop="id"
                    width="auto"
                    min-width="8%">
                  </el-table-column> -->

                  <el-table-column
                    label="品牌名称"
                    prop="brand"
                    width="auto"
                    min-width="20%">
                  </el-table-column>

                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="品牌名称" v-if="props.row.brand">
                          <span>{{ props.row.brand }}</span>
                        </el-form-item>
                        <el-form-item label="商品名称" v-if="props.row.name">
                          <span>{{ props.row.name }}</span>
                        </el-form-item>
                        <el-form-item label="所属店铺" v-if="props.row.shop">
                          <span>{{ props.row.shop }}</span>
                        </el-form-item>
                        <el-form-item label="商品属性" v-if="props.row.properties">
                          <span>{{ props.row.properties }}</span>
                        </el-form-item>
                        <el-form-item label="商品规格" v-if="props.row.specs">
                          <span>{{ props.row.specs }}</span>
                        </el-form-item>
                        <el-form-item label="商品位置" v-if="props.row.location">
                          <span>{{ props.row.location }}</span>
                        </el-form-item>
                        <el-form-item label="直播价" v-if="props.row.lowPrice">
                          <span>{{ props.row.lowPrice }}</span>
                        </el-form-item>
                        <el-form-item label="商品已拥有" v-if="props.row.hasString">
                          <span>{{ props.row.hasString }}</span>
                        </el-form-item>
                        <el-form-item label="商品描述" v-if="props.row.description">
                          <span>{{ props.row.description }}</span>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="商品名称"
                    width="auto"
                    min-width="38%"
                    prop="name">
                  </el-table-column>
                  <el-table-column
                    label="属性"
                    prop="properties"
                    width="auto"
                    min-width="20%">
                  </el-table-column>
                  <!-- <el-table-column
                    label="描述"
                    prop="desc">
                  </el-table-column> -->
                  <el-table-column label="操作"  width="auto" min-width="25%">
                    <template slot="header" slot-scope="scope">
                            <el-input
                            v-model="tableSearch"
                            size="mini"
                            placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                      <el-button v-if="tableState === 'Stocked'"
                        size="mini"
                        type="primary"
                        @click="show(scope.$index, scope.row)">查看</el-button>
                      <el-button v-if="tableState === 'Stocked'"
                        size="mini"
                        type="danger"
                        @click="handleMoveFromInventory( scope.$index, scope.row)">移除盘货</el-button>
                      <el-button v-if="tableState === 'UnStocked'"
                        size="mini"
                        type="primary"
                        @click="handleAddToInventory( scope.$index, scope.row)">加入盘货</el-button>
                    </template>
                  </el-table-column>
                </el-table>
            </el-card>
            <!-- margin-top:5%;margin-left:30%;margin-right:30% ; -->
            <div style=" left:50% ;bottom: 5%; position:fixed">
              <el-button
                      type="primary"
                      @click='dialogFormVisible = true'>创建盘货</el-button>
                    <el-button
                      type="danger"
                      @click="handlBeforeMoveInventory">删除盘货</el-button>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-dialog title="选择创建的盘货日期" :visible.sync="dialogFormVisible">
        <el-date-picker v-model="creatInventoryTime" type="month" placeholder="选择月" style="width:80%"> </el-date-picker>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="creatInventory">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'Inventory',
  data () {
    return {
      tableHight: window.innerHeight * 0.65,
      dialogFormVisible: false,
      creatInventoryTime: '',
      selectInventoryId: '',
      selectInventoryTime: '',
      inventoryTime: [],
      items: [],
      stockedItems: [],
      unStockedItems: [],
      tableState: '',
      stockedNum: 0,
      unStockedNum: 0,
      loadInfo: '暂无数据',
      tableSearch: ''
    }
  },
  mounted () {
    this.getAllInventory()
  },
  methods: {
    show (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/show',
        query: {
          id: row.id
        }
      })
      window.open(routeUrl.href, '_blank')
      console.log(row.id)
    },
    beforeFindItem (key, keyPath) {
      this.selectInventoryId = key
      this.tableState = ''
      for (var i in this.inventoryTime) {
        if (this.inventoryTime[i].id === this.selectInventoryId) {
          this.selectInventoryTime = this.inventoryTime[i].time
        }
      }
      // this.findItem(true)
      // this.findItem(false)
      // this.tableState = 'Stocked'
      // this.fillTable()
    },
    findItem () {
      // for (var i in this.inventoryTime) {
      //   if (this.inventoryTime[i].id === this.selectInventoryId) {
      //     this.selectInventoryTime = this.inventoryTime[i].time
      //   }
      // }
      this.items = []
      let flag = true
      if (this.tableState === 'UnStocked') flag = false
      this.loadInfo = '数据加载中'
      this.$axios.post(Common.baseUrl + 'inventoryHasGoods/findItemByInventoryId', {inventoryId: this.selectInventoryId, flag: flag}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.loadInfo = '数据加载完毕，暂无数据'
          this.items = res.data.data
          for (let i in this.items) {
            let hasList = this.items[i].has
            this.items[i].hasString = hasList.join(' · ')
          }
          // if (flag) {
          //   this.stockedItems = res.data.data
          //   for (let i in this.stockedItems) {
          //     let hasList = this.stockedItems[i].has
          //     this.stockedItems[i].hasString = hasList.join(' · ')
          //   }
          // } else {
          //   this.unStockedItems = res.data.data
          //   for (let i in this.unStockedItems) {
          //     let hasList = this.unStockedItems[i].has
          //     this.unStockedItems[i].hasString = hasList.join(' · ')
          //   }
          // }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    fillTable () {
      if (this.tableState === 'Stocked') this.items = this.stockedItems
      else this.items = this.unStockedItems
    },
    getAllInventory () {
      this.$axios.get(Common.baseUrl + 'inventoryTime/getAllInventory'
      ).then((res) => {
        let code = res.data.code
        this.inventoryTime = []
        if (code === 200) {
          for (var i in res.data.data) {
            let s = res.data.data[i].time
            let time = s.substring(0, s.indexOf(' '))
            let live = {id: res.data.data[i].id, time: time}
            this.inventoryTime.push(live)
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    creatInventory () {
      if (this.creatInventoryTime === '') {
        this.$message({
          message: '请输入时间',
          type: 'warning'
        })
        return
      }
      this.$axios.post(Common.baseUrl + 'inventoryTime/creatInventory', this.creatInventoryTime
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
        //   this.inventoryTime = []
        //   console.log(res.data.data)
        //   for (var i in res.data.data) {
        //     let s = res.data.data[i].time
        //     let time = s.substring(0, s.indexOf(' '))
        //     let live = {id: res.data.data[i].id, time: time}
        //     this.inventoryTime.push(live)
        //   }
          this.getAllInventory()
          this.dialogFormVisible = false
          this.$message({
            message: '创建盘货日期成功！',
            type: 'success'
          })
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handleMoveFromInventory (index, row) {
      this.$axios.post(Common.baseUrl + 'inventoryHasGoods/delete', {inventoryTimeId: this.selectInventoryId, goodsId: row.id}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.items.splice(index, 1)
          this.findItem(true)
          this.findItem(false)
          this.$message({
            message: '移除成功',
            type: 'success'
          })
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handleMoveInventory () {
      this.$axios.get(Common.baseUrl + 'inventoryTime/deleteById', {params: {id: this.selectInventoryId}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
          this.getAllInventory()
          this.selectInventoryId = ''
          this.selectInventoryTime = ''
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handlBeforeMoveInventory () {
      if (this.selectInventoryTime === '') {
        this.$message({
          message: '请重新选择盘货日期',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否删除盘货日期  ' + this.selectInventoryTime + '  ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleMoveInventory()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleAddToInventory (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/update',
        query: {
          id: row.id,
          timeId: this.selectInventoryId
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    downExcle () {
      let flag = true
      if (this.tableState === 'UnStocked') flag = false
      this.$axios({
        // 这里也可以是 blob
        responseType: 'blob',
        method: 'post',
        url: Common.baseUrl + 'inventoryHasGoods/downLoadInventory',
        params: {inventoryId: this.selectInventoryId, flag: flag}
      }).then((res) => {
        console.log(123)
        console.log(res)
        let code = res.status
        console.log(code)
        if (code === 200) {
          const { data, headers } = res
          const fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
          // 此处当返回json文件时需要先对data进行JSON.stringify处理，其他类型文件不用做处理
          const blob = new Blob([data], {type: headers['content-type']})
          let dom = document.createElement('a')
          let url = window.URL.createObjectURL(blob)
          dom.href = url
          dom.download = decodeURI(fileName)
          dom.style.display = 'none'
          document.body.appendChild(dom)
          dom.click()
          dom.parentNode.removeChild(dom)
          window.URL.revokeObjectURL(url)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Inventory.vue